.btn-information{margin:10px 0 0 10px;padding:3px 9px}.pagination{margin:10px 0}.task-settings{min-height:500px}
/*# sourceMappingURL=scheduler-reports-table.component-2AOHEO35.css.map */
